// Public site settings.
// Fetched once at boot from /api/public/settings. Consumers use `useSetting(key, fallback)`.

import { useEffect, useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const EVT = "zt-settings-changed";

let _settings = {};

if (typeof window !== "undefined") {
  fetch(`${BACKEND}/api/public/settings`)
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      if (data && data.items) {
        _settings = data.items;
        try { window.dispatchEvent(new CustomEvent(EVT)); } catch { /* noop */ }
      }
    })
    .catch(() => { /* keep empty */ });
}

export function getSetting(key, fallback) {
  return key in _settings ? _settings[key] : fallback;
}

export function useSetting(key, fallback) {
  const [value, setValue] = useState(() => getSetting(key, fallback));
  useEffect(() => {
    const on = () => setValue(getSetting(key, fallback));
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, [key, fallback]);
  return value;
}
